import { useMemo } from 'react';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { useFormValues } from '@s20/components/forms/FormContext';
import { DraggableResourceTypes } from '../../../dispatch/Dispatch';
import { useJobQueryKey } from '../common/useJobQueryKey.hook';

export const useTotalAvailableResources = () => {
    const {
        selectedJobId, selectedDate: date, selectedResourceType, selectedResourceGroup,
    } = useFormValues();

    const query = useJobQueryKey();
    const { data: jobData } = useQuery(query);

    const totalAvailable = useMemo(() => {
        if (!selectedJobId || !selectedResourceGroup) {
            return 0;
        }

        const job = jobData?.find((item) => item.id === selectedJobId || item.jobIdsInGroup?.includes(selectedJobId));
        const selectedDate = moment(date);

        const assignments = job?.assignments?.[selectedDate.day()];

        if (!assignments) {
            return 0;
        }

        // `assignment` (not `jobAssignmentId`) is the true signal that someone/something is there.
        if (selectedResourceType === DraggableResourceTypes.Staff) {
            return assignments.staff.filter((asn) => !asn.assignment && asn.id === selectedResourceGroup.id).length;
        }

        return assignments.equipment.filter((asn) => !asn.assignment && asn.requiredEquipment?.[0]?.id === selectedResourceGroup.requiredEquipment?.[0]?.id).length;
    }, [jobData, selectedJobId, selectedResourceType, date, selectedResourceGroup]);

    return totalAvailable;
};